import { Metric } from "@linkfluence/models/metric";
import { Card, DateMetricCard, DemographicCard, TermCard } from "..";
import { ComparisonPeriod } from "../period";
import { DateMetricCardFactory } from "./date.metric";
import { DemographicCardFactory } from "./demographic";
import { TermCardFactory } from "./term";
import { TimeUnit } from "./time-unit";

export class CardAdapter {
  public adaptToDemographicCard(
    workspaceId: number,
    projectFocuses: number[],
    card: Card,
    options?: {
      metric?: Metric;
      dataviz?: DemographicCard["dataviz"];
      comparisonPeriod?: ComparisonPeriod;
    }
  ) {
    return DemographicCardFactory.getInstance().fromCard(
      workspaceId,
      projectFocuses,
      card,
      options
    );
  }
  public adaptToDateMetricCard(
    workspaceId: number,
    projectFocuses: number[],
    card: Card,
    options?: {
      metric?: Metric;
      dataviz?: DateMetricCard["dataviz"];
      comparisonPeriod?: ComparisonPeriod;
      timeUnit?: TimeUnit;
    }
  ) {
    return DateMetricCardFactory.getInstance().fromCard(
      workspaceId,
      projectFocuses,
      card,
      options
    );
  }
  public adaptToTermCard(
    workspaceId: number,
    projectFocuses: number[],
    card: Card,
    options?: {
      metric?: Metric;
      dataviz?: TermCard["dataviz"];
      comparisonPeriod?: ComparisonPeriod;
    }
  ) {
    return TermCardFactory.getInstance().fromCard(
      workspaceId,
      projectFocuses,
      card,
      options
    );
  }
}
